<div class="page">
    <app-step-progress [steps]="steps"></app-step-progress>
    <div
        *ngIf="hasOSRReg"
        class="p-0"
    ><span class="required fa fa-asterisk"></span> Indicates required fields.</div>
    <app-page-title [title]="'Review and payment'"></app-page-title>

    <app-order-items
        *ngIf="shoppingCart"
        [shoppingCart]="shoppingCart"
        (applyDiscount)="applyDiscountCode($event)"
    ></app-order-items>

    <div
        *ngIf="hasOSRReg"
        class="m-4 p-0"
    >
        <p style="font-weight: 500; font-size: 18px;">
            You must arrive 45 MINUTES prior to your CELPIP One Skill Retake. Check-in for your retake closes 15 MINUTES before the scheduled start time. If you arrive after this time, you will be denied entrance to the CELPIP-General Test and will not be eligible for a refund or transfer.
        </p>
        <div class="custom-control custom-checkbox mb-2">
            <input
                type="checkbox"
                class="custom-control-input"
                name="arrivalTime-Check"
                id="arrivalTime-Check"
                [(ngModel)]="arrivalTimeCheck"
            >
            <label
                class="custom-control-label"
                for="arrivalTime-Check"
            >I have read and understood the above statement. <span class="required fa fa-asterisk"></span></label>
        </div>
    </div>

    <app-shipping-address
        *ngIf="shippingAddress && billingAddress"
        [shippingAddress]="shippingAddress"
        [billingAddress]="billingAddress"
    ></app-shipping-address>

    <div *ngIf="paymentMethods && paymentMethods.length > 1">
        <div class="row">
            <div class="col-md-12">
                <h5>Select a Payment Option</h5>
                <br />
            </div>
        </div>
        <div class="col-md-12">
            <div
                class="form-group"
                style="margin-top: -10px;"
            >
                <div *ngFor="let paymentMethod of paymentMethods">
                    <label>
                        <input
                            type="radio"
                            name="radPaymentMethod"
                            value="{{paymentMethod.id}}"
                            [checked]="paymentMethod.id === selectedPaymentMethodId"
                            (click)="selectPaymentMethod(paymentMethod)"
                        >
                        {{paymentMethod.name}} <span *ngIf="paymentMethod.id === 1">(You will be redirected to our payment processor's secure payment page)</span>
                    </label>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="selectedPaymentMethodId">
        <div class="row">
            <div class="col-md-12">
                <h5>Payment Option: <strong style="text-decoration: underline;"> {{selectedPaymentMethodName}} </strong></h5>
                <br />
                <p *ngIf="selectedPaymentMethodId === paymentMethodInvoiceId">Please note that you are processing this payment through our invoicing option. You will be invoiced at a later date for the amount owing displayed here. If this is not correct, please let us know at your earliest convenience so we can make the appropriate corrections.</p>
            </div>
        </div>
    </div>
    <div class="row p-2">
        <div class="col-md-12">
            <div class="form-group">
                <a
                    href="{{regPoliciesUrl}}"
                    target="_blank"
                >View our transfer, cancellation, and retake policies.</a>
                <br /><br />
                <div *ngIf="selectedPaymentMethodId !== paymentMethodInvoiceId">
                    <p *ngIf=" shoppingCart?.total > 0 && (!paymentMethods || paymentMethods.length === 0)">You will be redirected to our payment processor's secure payment page.</p>
                    <p>To ensure that your browser is compatible with our payment processor<span *ngIf="brandId === BrandEnum.CELPIP"> and learn more about the accepted payment methods</span>, click
                        <span><a
                                target="_blank"
                                href="{{browserRequirementsUrl}}"
                            >here</a>.</span>
                    </p>
                    <span *ngIf="!paymentInfo">
                        <strong style="color: red; font-size: larger;">We accept VISA ®, Mastercard ®, American Express ®, and payments through PayPal. </strong>
                    </span>
                    <span *ngIf="paymentInfo">
                        <strong style="color: red; font-size: larger;">{{paymentInfo}} </strong>
                    </span>
                    <br /><br />
                    <form
                        name="checkout-payment-form"
                        method="post"
                        id="exactForm"
                    >
                        <input
                            type="hidden"
                            id="x_login"
                            name="x_login"
                            value=""
                        />
                        <input
                            type="hidden"
                            id="x_fp_sequence"
                            name="x_fp_sequence"
                            value=""
                        />
                        <input
                            type="hidden"
                            id="x_fp_timestamp"
                            name="x_fp_timestamp"
                            value=""
                        />
                        <input
                            type="hidden"
                            id="x_amount"
                            name="x_amount"
                            value=""
                        />
                        <input
                            type="hidden"
                            id="x_fp_hash"
                            name="x_fp_hash"
                            value=""
                        />
                        <input
                            type="hidden"
                            id="x_show_form"
                            name="x_show_form"
                            value=""
                        />
                        <input
                            type="hidden"
                            id="x_currency_code"
                            name="x_currency_code"
                            value=""
                        />
                        <input
                            type="hidden"
                            id="x_first_name"
                            name="x_first_name"
                            value=""
                        />
                        <input
                            type="hidden"
                            id="x_last_name"
                            name="x_last_name"
                            value=""
                        />
                        <input
                            type="hidden"
                            id="x_email"
                            name="x_email"
                            value=""
                        />
                        <input
                            type="hidden"
                            id="x_invoice_num"
                            name="x_invoice_num"
                            value=""
                        />
                        <input
                            type="hidden"
                            id="x_reference_3"
                            name="x_reference_3"
                            value=""
                        />
                        <input
                            type="hidden"
                            id="userAccountId"
                            name="userAccountId"
                            value=""
                        />
                        <input
                            type="hidden"
                            id="orderNumber"
                            name="orderNumber"
                            value=""
                        />
                    </form>
                    <form
                        id=ccavenueForm
                        method="post"
                        name="redirect"
                        action=""
                    >
                        <input
                            type="hidden"
                            id="encRequest"
                            name="encRequest"
                            value=""
                        />
                        <input
                            type="hidden"
                            id="access_code"
                            name="access_code"
                            value=""
                        />
                    </form>
                    <form
                        id=paymentechHPPForm
                        name="form1"
                        method="get"
                        action="https://placeholder/hpp/"
                    >
                        <input
                            type="hidden"
                            id="uid"
                            name="uid"
                            value=""
                        />
                    </form>
                </div>
                <button
                    type="button"
                    name="confirmationYesBtn"
                    *ngIf="shoppingCart"
                    (click)="placeOrder()"
                    [disabled]="(shoppingCart?.length === 0 && shoppingCart?.total <= 0) || (paymentMethods?.length > 0 && !selectedPaymentMethodId) || (hasOSRReg && !arrivalTimeCheck)"
                    class="btn btn-primary"
                >{{shoppingCart.total > 0 ? 'Place Order' : 'Complete Order'}}</button>
            </div>
        </div>
    </div>
</div>
